import React, { FunctionComponent, useState, useEffect } from "react";

import * as MarketingApi from "../../../api/marketingApi";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { isOk } from "../../../result";
import { useI18n } from "../../../hooks/useI18n";

interface NotificationTypeSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
  onSelected: (item?: string) => void;
}

export const NotificationTypeSelect: FunctionComponent<
  NotificationTypeSelectProps
> = ({
  label,
  required = false,
  disabled = false,
  onSelected,
  onChange,
  variant = "standard",
  value,
  error = false,
  ...props
}) => {
  const { t } = useI18n();
  const [state, setState] = useState<ReadonlyArray<string>>([]);
  const displayLabel = label || t("common.formFields.notificationType");

  useEffect(() => {
    MarketingApi.getSelectableValues().then(result => {
      if (isOk(result)) {
        setState(result.value.notificationTypes);
      }
    });
  }, []);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let item = state.find(i => i === event.target.value);
      if (item) {
        onSelected(item);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  return (
    <FormControl
      variant={variant}
      className={props.className}
      error={error}
      required={required}
      disabled={disabled}
    >
      <InputLabel
        id="notification-type-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {displayLabel}
      </InputLabel>
      <Select
        value={value ?? ""}
        onChange={handleChange}
        labelId="notification-type-select-label"
        id="notification-type-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state.map(x => (
            <MenuItem key={x} value={x}>
              {x}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
